<template>
    <div class="printOrderListBox">
        <el-tabs v-model="activeName" class="orderListTabs" @tab-click="searchInfo">
            <el-tab-pane
                v-for="item in tabList"
                :key="item.id"
                :label="item.name"
                :name="item.id"
            >
            </el-tab-pane>
        </el-tabs>
        <div>
            <div class="orderSearchBox">
                <!--<el-date-picker
                    v-model="createDateValue"
                    type="date"
                    placeholder="创建时间"
                >
                </el-date-picker>-->
                <div class="timeSearch">
                    <span style="color: #b2b2b2;">区间筛选</span>
                    <el-date-picker
                        v-model="createDateValue"
                        @change="chooseDate"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="—"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </div>
                <el-input v-model="modelNameValue" placeholder="需求名称"></el-input>
                <el-input v-model="merchantNameValue" placeholder="设计师名称"></el-input>
                <el-input v-model="demandPerson" placeholder="需求方名称"></el-input>
                <el-input v-model="orderNumberValue" placeholder="订单编号"></el-input>
                <el-button class="searchBtn" @click="searchInfo">搜索</el-button>
                <el-button type="text" class="resetBtn" @click="clearSearch">
                    <i class="iconfont icon-qingchushujuku"></i>
                    <span>清除条件</span>
                </el-button>
            </div>
            <div class="orderListTable">
                <ul class="tableHeader">
                    <li class="name">需求内容</li>
                    <li class="price">预算</li>
                    <li class="time">报价截止日期</li>
                    <li class="num">报价人数</li>
                    <li class="designer">设计师</li>
                    <li class="offer">报价</li>
                    <li class="expect">预计交付</li>
                    <li class="status">订单状态</li>
                </ul>
                <ul class="tableBody" v-if="designList.length != 0" v-loading="loading">
                    <li
                        class="bodyItem"
                        v-for="(designItems, designIndex) in designList"
                        :key="designIndex"
                    >
                        <div class="itemTop">
                            <div>创建时间：{{ designItems.orderBase.createDate }}</div>
                            <div>订单编号：{{ designItems.orderBase.orderNo }}</div>
                        </div>
                        <div class="itemBottom">
                            <div class="name">
                                <div class="orderInfo">
                                    <div class="infoContent">
                                        <div class="infoName">{{ designItems.demandName }}</div>
                                        <div class="infoOther">
                                            {{ designItems.demandRemark }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="price">¥{{ designItems.lowPreAmount }}-{{ designItems.highPreAmount }}</div>
                            <div class="time">{{ designItems.deadLine }}</div>
                            <div class="num">{{ designItems.offerNum }}</div>
                            <div class="designer">
                                <div class="designerName">{{ designItems.designerName }}</div>
                            </div>
                            <div class="offer">{{ designItems.offerPrice }}</div>
                            <div class="expect">{{ designItems.planDeliveryTime }}</div>
                            <div class="status">
                                {{ designItems.designStatusCn }}
                                <el-button type="text" class="operationBtn" @click="designOrderDetail(designItems)">订单详情</el-button>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="orderNomesaage" v-loading="loading" v-else >暂无数据</div>
            </div>
        </div>
        <el-pagination
            v-if="designList.length != 0"
            background
            @current-change="handleCurrentChange"
            @prev-click="handleCurrentChange"
            @next-click="handleCurrentChange"
            layout="total,prev, pager, next,jumper"
            :current-page="pageNo"
            :page-size="pageSize"
            :total="total"
            class="pagination"
        >
        </el-pagination>
    </div>
</template>

<script>
import { getDesignOrderList } from '../../utils/interface';
export default {
    name: "designerOrderList",
    data() {
        return {
            loading: true,
            activeName: "0",
            tabList: [
                {
                    id: '',
                    name: '全部'
                },
                {
                    id: 'UN_PAY',
                    name: '待付款'
                },
                // {
                //     id: "OFFLINE_UN_CONFIRM",
                //     name: "线下支付待确认",
                // },
                {
                    id: 'UN_DESIGN',
                    name: '设计中'
                },
                {
                    id: 'UN_CONFIRM',
                    name: '设计待确认'
                },
                {
                    id: 'UN_APPRAISE',
                    name: '待评价'
                },
                {
                    id: "AFTER_SALES",
                    name: "退款/售后",
                },
            ],
            createDateValue: null,
            startTime:"",
            endTime:"",
            modelNameValue: "",
            merchantNameValue: "",
            demandPerson:"",
            orderNumberValue: "",
            orderStatusValue: "",
            evaluateStatusValue: "",
            postSalesServiceValue: "",
            designList: [],
            //   分页
            pageNo: 1,
            total: 0,
            pageSize: 8,
        };
    },
    created(){
        this.getList();
    },
    methods: {
        clearSearch(){
            this.modelNameValue = '';
            this.merchantNameValue = '';
            this.demandPerson = '';
            this.orderNumberValue = '';
            this.orderStatusValue = '';
            this.evaluateStatusValue = '';
            this.postSalesServiceValue = '';
            this.createDateValue = null;
            this.startTime = "";
            this.endTime = "";
            this.searchInfo();
        },
        searchInfo(){
            this.pageNo = 1;
            this.getList();
        },
        getList(){
            this.loading = true;
            let params = {
                platformAdvances:false,
                orderNo:this.orderNumberValue,
                demandName:this.modelNameValue,
                designerName:this.merchantNameValue,
                demandPerson:this.demandPerson,
                //createDate:this.createDateValue==null?null : this.createDateValue.getFullYear() +'-'+ (this.createDateValue.getMonth() + 1) +'-'+this.createDateValue.getDate(),
                startDate:this.startTime,
                endDate:this.endTime,
                orderStatus:this.activeName=='0'?'':this.activeName,
                current:this.pageNo,
                pageSize:this.pageSize
            };
            getDesignOrderList(params).then((res)=>{
                this.designList = res.data;
                this.total = res.total;
                this.loading = false
            });
        },
        // 分页
        handleCurrentChange(val) {
            this.pageNo = val;
            this.getList();
        },
        // 订单详情
        designOrderDetail(item){
            this.$router.push({name:'designOrderDetail',params:{uuid:item.uuid}});
        },
        // 时间格式
        chooseDate(){
            this.startTime = "";
            this.endTime = "";
            // 判断时间
            if(this.createDateValue!=null && this.createDateValue.length==2){
                this.startTime = this.timeDate(this.createDateValue[0]);
                this.endTime = this.timeDate(this.createDateValue[1]);
            }
        },
        timeDate(value){
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + MM + "-" + d;
        },
    },
};
</script>

<style scoped lang="less">
.printOrderListBox {
    background: #fff;
    min-height: 1011px;
    padding: 94px 20px 20px;
    margin-left: 20px;
    .orderListTabs {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 999;
        background: #fff;
        width: 100%;
        padding: 20px;
        margin-left: 20px;
    }
    /deep/ .el-tabs__item {
        padding: 0 25px !important;
        text-align: center;

        &:hover {
            color: #3686d7;
        }

        &:after {
            content: "";
            position: absolute;
            right: 0;
            bottom: 12px;
            width: 1px;
            height: 15px;
            background-color: #e4e7ed;
            z-index: 1;
        }

        &:last-child:after {
            content: "";
            width: 0;
            height: 0;
        }
    }

    /deep/ .el-tabs__active-bar {
        height: 3px;
        background-color: #3686d7;
    }

    /deep/ .el-tabs__item.is-active {
        color: #3686d7;
    }

    /deep/ .el-tabs__nav-wrap::after {
        height: 1px;
    }

    .orderSearchBox {
        .timeSearch {
            background-color: #f2f4f7;
            height: 35px;
            display: flex;
            align-items: center;
            margin-bottom: 22px;
            margin-right: 30px;
            border-radius: 8px;

            span {
                font-size: 12px;
                color: #c0c4cc !important;
                font-weight: normal;
                padding-left: 15px;
                margin-right: 5px;
            }

            // /deep/ .el-range-input{
            //         background-color: #f2f4f7;
            //             &:hover, &:focus {
            //             background-color: #fff;
            //             // border: 1px solid #108EE9;
            //         }
            // }
            /deep/ input::-webkit-input-placeholder {
                color: #c0c4cc;
                font-size: 12px;
            }

            /deep/ .el-range-input:hover {
                background-color: #fff !important;
            }

            /deep/ .el-date-editor .el-range-separator {
                line-height: 25px;
                color: #c0c4cc;
            }

            /deep/ .el-date-editor .el-range__close-icon {
                line-height: 28px;
            }

            /deep/ .el-input__inner:hover .el-range-input, /deep/ .el-input__inner:focus .el-range-input {
                background-color: white;
            }

            /deep/ .el-input__inner {
                width: 225px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                .el-range-input {
                    background-color: #f2f4f7;
                }

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;

                }
            }
        }
        display: flex;
        flex-wrap: wrap;

        /deep/ .el-input {
            width: initial;
            margin-bottom: 22px;
            margin-right: 30px;
        }

        /deep/ .el-input__inner {
            width: 242px;
            height: 35px;
            min-height: 35px;
            font-size: 12px;
            color: #999999;
            background-color: #f2f4f7;
            border: 1px solid #f2f4f7;
            border-radius: 5px;

            &:hover,
            &:focus {
                background-color: #fff;
                border: 1px solid #108ee9;
            }
        }

        /deep/ .el-input__prefix {
            top: -3px;
        }

        /deep/ .el-input__suffix {
            top: 2px;
        }

        /deep/ .el-button {
            display: block;
            line-height: 35px;
            padding: 0;
            height: 35px;
        }

        .searchBtn {
            width: 82px;
            background: #3d7fff;
            border: none;
            border-radius: 15px;
            font-size: 14px;
            color: #ffffff;
            margin-bottom: 22px;
        }

        .resetBtn {
            color: #333333;
            margin-bottom: 22px;
        }
    }

    .orderListTable {
        .orderNomesaage {
            color: #888;
            text-align: center;
            padding: 15px 0;
        }
        .tableHeader {
            display: flex;
            width: 100%;
            height: 35px;
            line-height: 35px;
            background: #f3f7ff;
            border-radius: 5px;
            margin: 0 0 15px;
            li {
                text-align: center;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.85);
            }
        }

        .tableBody {
            li {
                width: 100%;
                border: 1px solid #f2f2f2;
                border-radius: 10px;
                margin-bottom: 16px;

                .itemTop {
                    width: 100%;
                    height: 42px;
                    background: #ebf3fb;
                    line-height: 42px;
                    font-size: 14px;
                    color: #333;
                    padding: 0 20px;
                    display: flex;
                    align-items: center;
                    position: relative;

                    div {
                        margin-right: 30px;
                    }

                    .merchantInfo {
                        display: flex;
                        align-items: center;

                        i {
                            color: #3d7fff;
                            font-size: 25px;
                            cursor: pointer;
                            padding-left: 5px;
                            display: block;
                        }

                        img {
                            display: block;
                            padding-right: 5px;
                        }
                    }

                    .complainBtn {
                        color: #999;
                        position: absolute;
                        right: 20px;
                    }
                }

                .itemBottom {
                    display: flex;
                    align-items: center;
                    color: #333;
                    font-size: 13px;

                    .orderInfo {
                        padding: 20px;
                        display: flex;

                        img {
                            display: block;
                            width: 100px;
                            height: 100px;
                            border-radius: 10px;
                            margin-right: 30px;
                        }

                        .infoContent {
                            .infoName {
                                font-size: 14px;
                                color: #000000;
                                padding-bottom: 10px;
                            }

                            .infoOther {
                                font-size: 13px;
                                color: #999999;
                                padding-bottom: 2px;
                                -webkit-line-clamp: 3;
                                -webkit-box-orient: vertical;
                                display: -webkit-box;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            }
                        }
                    }

                    .designer {
                        padding: 20px;
                    }

                    .designerName {
                        padding-bottom: 8px;
                        img {
                            width: 30px;
                            height: 30px;
                            border-radius: 50%;
                        }
                    }
                    .status {
                        font-size: 14px;
                    }
                    .operationBtn {
                        display: block;
                        color: #0c75d3;
                        text-align: center;
                        width: 100%;
                        margin: 0;
                    }
                }
            }
        }

        .name {
            flex: 1;
        }

        .price {
            width: 120px;
            text-align: center;
        }
        .time {
            width: 120px;
            text-align: center;
        }
        .num {
            width: 95px;
            text-align: center;
        }
        .designer {
            width: 95px;
            text-align: center;
        }
        .arguments {
            width: 294px;
        }

        .offer {
            width: 162px;
            text-align: center;
        }
        .expect {
            width: 162px;
            text-align: center;
        }
        .status {
            width: 124px;
            text-align: center;
        }
        .operation {
            width: 124px;
            text-align: center;
            .operationUploadBtn{
                width: 102px !important;
                height: 34px;
                padding: 0;
                line-height: 34px;
                text-align: center;
                font-weight: 700;
                color: rgba(0, 102, 204, 0.8);
                font-size: 14px;
                border-color: rgba(0, 102, 204, 0.8);
                display: block;
                margin: 0 auto 10px !important;
            }
        }
    }
    .pagination {
        margin-top: 20px;
        text-align: right;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/designOrderList.vue